"use client";

import { useQuery } from "@tanstack/react-query";
import { useParams } from "next/navigation";
import Loader from "@/components/Loader";
import {
  PriceListExperience,
  PriceListProperty,
} from "@/components/v2/pricelist/PriceListExperience";
import { PriceListUnit } from "@/components/v2/pricelist/PriceListTable";
import { getPriceList } from "@/lib/db/price-list";
import { getSinglePropertyByName } from "@/lib/db/property";

export default function PriceListPage() {
  const { id } = useParams<{ id: string }>();
  const priceListQuery = useQuery({
    queryKey: ["property-price-list", id],
    queryFn: () => getPriceList({ id }),
  });
  const propertyQuery = useQuery({
    queryKey: ["single-property", id],
    queryFn: () => getSinglePropertyByName(id),
  });

  if (priceListQuery.isLoading || propertyQuery.isLoading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <Loader />
      </div>
    );
  }

  const property =
    propertyQuery.data && typeof propertyQuery.data === "object"
      ? (propertyQuery.data as PriceListProperty)
      : undefined;
  const units = Array.isArray(priceListQuery.data)
    ? (priceListQuery.data as PriceListUnit[])
    : [];

  return (
    <PriceListExperience
      routeId={id}
      property={property}
      units={units}
      loadError={priceListQuery.isError || priceListQuery.data === null}
    />
  );
}
